"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _syncBrandingSettings = _interopRequireDefault(require("../../../actions/branding/syncBrandingSettings"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function syncedBrandingSettings(_ref, _ref2) {
  var dispatch = _ref.dispatch;
  var brandingSettings = _ref2.brandingSettings;
  dispatch((0, _syncBrandingSettings["default"])(brandingSettings));
}
var _default = exports["default"] = syncedBrandingSettings;